import { locKeys } from "../components/l10";
import type { ILocalization } from "@shared-ui/localization-context";
import type { FlightsLink } from "typings/microserviceModels/flights-flex-module";

export interface A11yMessageParams {
  airCarrier: string;
  isOneWay: boolean;
  flight: FlightsLink;
  formattedElapsedTime: string;
  showCityName: boolean;
}

export const getA11yMessage = (params: A11yMessageParams, formatText: ILocalization["formatText"]) => {
  const { airCarrier, isOneWay, formattedElapsedTime, flight, showCityName } = params;

  const originAirport = showCityName ? flight.origin.cityName : flight.origin.name;
  const destinationAirport = showCityName ? flight.destination.cityName : flight.destination.name;

  const oneWayMessageArgs = [
    airCarrier,
    flight.formattedDepartureDate,
    originAirport,
    destinationAirport,
    flight.formattedTicketPrice,
    formattedElapsedTime,
  ];
  const roundTripMessageArgs = [
    airCarrier,
    flight.formattedDepartureDate,
    originAirport,
    destinationAirport,
    flight.formattedReturnDate,
    flight.formattedTicketPrice,
    formattedElapsedTime,
  ];

  return isOneWay
    ? formatText(locKeys.flightAccessibilityMessageOneWay, ...oneWayMessageArgs)
    : formatText(locKeys.flightAccessibilityMessageRoundTrip, ...roundTripMessageArgs);
};
